import React from 'react';
import {Card, Block, ModalComponentProps, Dialog, DialogBody, DialogFooter, Button, VF, makeValidate, Space, Col, Row, Spinner, Yup} from '@mc/ui-v4';
import {Form, FormRenderProps} from 'react-final-form';
import {FulltextSearchResultVO, LayerSettingsApi} from '../../../api';
import {printFormatterFulltextSearchResultVO} from '../../../helpers/Formatter';
import {actionApiCall} from '@mc/react-app-v4';
import {renderUsersOfEntity} from './OpravneniModal';

type Props = ModalComponentProps & {
    topicLabel: string;
    onSubmit: (data: SingleOpravneniProps) => void;
};

export type SingleOpravneniProps = {
    entita?: FulltextSearchResultVO;
};
export const CreateTopicOwnerModal: React.FC<Props> = ({onClose, onSubmit, topicLabel}) => {
    const validateSchema = Yup.object().shape({
        entita: Yup.object().required('Entita je povinná'),
    });
    const validation = makeValidate(validateSchema);

    return (
        <Form<SingleOpravneniProps>
            onSubmit={onSubmit}
            validate={async data => {
                return await validation(data);
            }}
        >
            {({submitting, handleSubmit, values}: FormRenderProps<SingleOpravneniProps>) => {
                return (
                    <Dialog size="md" onClose={onClose} title={`Přidat vlastníka tématu - ${topicLabel}`}>
                        {submitting && (
                            <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                                <Spinner />
                            </div>
                        )}
                        <DialogBody>
                            <Space vertical>
                                <Card mode={'edit'}>
                                    <Block>
                                        <Row>
                                            <Col>
                                                <VF.Autocomplete
                                                    onSearchItems={async text =>
                                                        await actionApiCall(async () => (await LayerSettingsApi.getAllEntitiesFulltext(text)).data)
                                                    }
                                                    getItemName={(item: FulltextSearchResultVO) => {
                                                        return item ? printFormatterFulltextSearchResultVO(item) : '';
                                                    }}
                                                    label={'Entita'}
                                                    name={'entita'}
                                                />
                                            </Col>
                                        </Row>
                                        {renderUsersOfEntity(values.entita)}
                                    </Block>
                                </Card>
                            </Space>
                        </DialogBody>
                        <DialogFooter>
                            <Button style="default" onClick={onClose} disabled={submitting}>
                                Zrušit
                            </Button>
                            <Button style="primary" onClick={handleSubmit} disabled={submitting}>
                                Uložit
                            </Button>
                        </DialogFooter>
                    </Dialog>
                );
            }}
        </Form>
    );
};
